<template>
    <b-row>
    <b-col cols="12">
      <b-btn variant="danger" @click.stop="backToDashboard()">Return to Dashboard</b-btn>
      <hr>
      <b-jumbotron>
        <b-form @submit="onSubmit">
          <b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Event Title:">
            <b-form-input required id="title" v-model.trim="event.title"></b-form-input>
          </b-form-group>
          
          <b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Event Date:">
              <b-form-input required id="event_date" type="date" v-model.trim="event.event_date"></b-form-input>
          </b-form-group>

          <b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Start Time:">
              <b-form-input required id="start_time" type="time" v-model.trim="event.start_time"></b-form-input>
          </b-form-group>

          <b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Finish Time:">
              <b-form-input required id="end_time" type="time" v-model.trim="event.end_time"></b-form-input>
          </b-form-group>

          <b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Discipline:">
            <b-form-select required id="discipline" v-model.trim="event.discipline">
              <option value="Rifle">Rifle</option>
              <option value="Mini-Rifle">Mini-Rifle</option>
              <option value="Clay Pigeon">Clay Pigeon</option>
            </b-form-select>
          </b-form-group>

          <b-form-group id="fieldsetHorizontal"
                      horizontal
                      :label-cols="4"
                      breakpoint="md"
                      label="Competition:">
              <b-form-select required id="competition" v-model.trim="event.competition">
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </b-form-select>
            </b-form-group>

          <b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Location:">
            <b-form-select required id="location" v-model.trim="event.location">
              <option value="Bridgeton">Bridgeton</option>
              <option value="Binn Hill">Binn Hill</option>
              <option value="Other">Other (see desc.)</option>
            </b-form-select>
          </b-form-group>

          <!--<b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Position:">
            <b-form-select required id="position" v-model.trim="event.position">
              <option value="President">President</option>
              <option value="Vice President">Vice President</option>
              <option value="Secretary">Secretary</option>
              <option value="Treasurer">Treasurer</option>
            </b-form-select>
          </b-form-group>-->

          <!--<b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Author:">
            <b-form-input required id="author" v-model.trim="event.author"></b-form-input>
          </b-form-group>-->

          <b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Description:">
            <b-form-textarea required id="description"
                        v-model="event.description"
                        :rows="10"
                        :max-rows="25">
                        {{event.description}}
            </b-form-textarea>
          </b-form-group>

          <b-button type="submit" variant="primary">Save</b-button>
        </b-form>
      </b-jumbotron>
    </b-col>
  </b-row>
</template>

<script>
import router from '../router/index.js'
import firebase from '../Firebase'

export default {
    name: 'AddEvent',
    data () {
      return {
        ref: firebase.firestore().collection('events'),
        currentUser: firebase.auth().currentUser,
        event: {},
        scrolled: false
      }
    },
    mounted() {
    firebase.firestore().collection('users').doc(this.currentUser.email).get().then(
        docSnapshot => {
          if (!docSnapshot.exists) return;
          let data = docSnapshot.data()

          var name = data.name
          var position = data.position
          var today = new Date();
          var dd = today.getDate();
          var mm = today.getMonth() + 1; //January is 0!

          var yyyy = today.getFullYear();
          if (dd < 10) {
          dd = '0' + dd;
          } 
          if (mm < 10) {
          mm = '0' + mm;
          } 
          today = yyyy + '-' + mm + '-' + dd;

          this.event.author = name
          this.event.position = position
          this.event.date_posted = today
        })
  },
    methods: {
      onSubmit (evt) {
        evt.preventDefault()

        this.ref.add(this.event).then((docRef) => {
          this.event.author = '',
          this.event.competition = '',
          this.event.date_posted = '',
          this.event.description = '',
          this.event.discipline = '',
          this.event.end_time = '',
          this.event.event_date = '',
          this.event.location = '',
          this.event.position = '',
          this.event.start_time = '',
          this.event.title = '',
          
          router.push({
            name: 'Dashboard'
          })
        })
        .catch((error) => {
          alert("Error adding event: ", error);
        });
      },

      backToDashboard() {
        router.push({ name: 'Dashboard'})
      }
    }
}
</script>

<style>

</style>
